import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { CountrySelect, ICountrySelectProps } from './CountrySelect';
import * as _ from 'lodash';

const GetCountryListQuery = gql`
  query {
    countries {
      id
      name
      title
      code
      VATrate
      states {
        name
        vatRate
      }
    }
  }
`;

export default withRouter(compose<{}, ICountrySelectProps>(
  graphql<ICountrySelectProps, any>(GetCountryListQuery, {
    name: 'countries',
    options: props => ({
      variables: {
        domain: props.match.params.eshop
      }
    })
  }),
  withProps(({ countries }: any) => {
    return {
      countries: countries.countries,
    };
  }),
)(CountrySelect));



// WEBPACK FOOTER //
// ./src/components/Others/CountrySelect/index.ts